import { API_ENDPOINTS } from "./apiCall";

const BASE = API_ENDPOINTS.API_COMMAN_URL + 'Production/';

export const Production_API_ENDPOINTS = {

  //QC Certificate SPEC DATA 
  PRODUCTION_SAVE_QC_SPEC_DATA: `${BASE}saveJumboWiseQualtiyCertificateSpecificationDetails`,
  GetIndentInvoiceNoForQCCertificate: `${BASE}GetIndentInvoiceNoForQCCertificate`,
  linkInvoiceNoToIndentNoForQCCertificate: `${BASE}link_invoice_to_indent_for_qc_certificate`,
  PRODUCTION_GET_QC_CERTIFICATE_DETAILS_BY_ORDERNO: `${BASE}getOrderNoWiseQualtiyCertificateAndSpecDetailsOrderNo`,
  GetAllInvoiceNoForQCCertificate: `${BASE}GetAllInvoiceNoForQCCertificate`,
  GetIndentNoListByInvoiceNo: `${BASE}GetIndentNoListByInvoiceNo`,
  CrudQualityCertificatePropertyMaster: `${BASE}CrudQualityCertificatePropertyMaster`,
  getQualityCertificatePropertyList: `${BASE}getQualityCertificatePropertyList`,
  getMasterQCPropertyList: `${BASE}getMasterQCPropertyList`,
  FGStockUpdate: `${BASE}FG_Stock_update`,
  GetManualIndentNoByIndentAndInvoiceNo: `${BASE}GetManualIndentNoByIndentAndInvoiceNo`,
  ProductonSummaryToday: `${BASE}get-production-list-today`,
  ProductonSummaryMonthWise: `${BASE}get-production-list-month-wise`,
  ProductonSummaryRemarkWise: `${BASE}get-production-list-remark-wise`,
  ProductionUpdateChildReelGrade: `${BASE}update-child-reel-grade`,

  repulp: {
    list: `${BASE}Repulp-waste-entry-list`,
    getById: `${BASE}Repulp-waste-entry-list_getById`,
    create: `${BASE}Repulp-waste-entry-list-insert`,
    update: `${BASE}Repulp-waste-entry-list`,
    delete: `${BASE}Delete-Repulp-waste-entry-list`,
    getListByStatus: `${BASE}Repulp-waste-entry-list`,
    locationList: `${BASE}Repulp-waste-location-list`,
    machineList: `${BASE}Repulp-waste-machine-list`,
    WasteTypeList: `${BASE}Repulp-waste-type-list`,
    shiftList: `${BASE}Repulp-waste-shift-list`,
    shiftInchargeList: `${BASE}Repulp-waste-shift_incharge-list`,
    SummaryReport: `${BASE}Repulp-waste-summary-report`,
  },
  repulpmaster: {

    wastelocationlist: `${BASE}Repulp-waste-location-master-list`,
    wastelocationcreate: `${BASE}Save_Master_Repulp_Location`,
    wastelocationdelete: `${BASE}Delete-Master-Repulp-Waste-Location`,
    wastetypelist: `${BASE}Repulp-waste-type-master-list`,
    wastetypecreate: `${BASE}Save-Master-Repulp-Waste-Type`,
    wastetypedelete: `${BASE}Delete-Master-Repulp-Waste-Type`,
  },

  qrScanning: {
    validate: `${BASE}qr-validate`,
    save: `${BASE}qr-save`,
  },

  reports: {
    REPORT_GetStockStackingReport: `${BASE}get-stock-stacking-report`,
    REPORT_getscanlocations: `${BASE}get-scan-locations`,
  },

};
